import SvgIcon from '@mui/material/SvgIcon';

export default function OfficeAddIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg
                viewBox="0 0 24 24"
                version="1.1"
                id="svg19"
                xmlns="http://www.w3.org/2000/svg">
                <defs
                    id="defs23" />
                <path
                    id="path17"
                    fill='currentColor'
                    d="M 11.621094 3 A 5.5 5.5 0 0 1 12.96875 5.4394531 L 12.96875 5 L 14.96875 5 L 14.96875 7 L 13.121094 7 A 5.5 5.5 0 0 1 7.6386719 12.291016 A 5.5 5.5 0 0 1 2.96875 9.6757812 L 2.96875 21 L 10.96875 21 L 10.96875 17 L 12.96875 17 L 12.96875 21 L 20.96875 21 L 20.96875 11 L 16.96875 11 L 16.96875 3 L 11.621094 3 z M 12.96875 9 L 14.96875 9 L 14.96875 11 L 12.96875 11 L 12.96875 9 z M 4.96875 13 L 6.96875 13 L 6.96875 15 L 4.96875 15 L 4.96875 13 z M 8.96875 13 L 10.96875 13 L 10.96875 15 L 8.96875 15 L 8.96875 13 z M 12.96875 13 L 14.96875 13 L 14.96875 15 L 12.96875 15 L 12.96875 13 z M 16.96875 13 L 18.96875 13 L 18.96875 15 L 16.96875 15 L 16.96875 13 z M 4.96875 17 L 6.96875 17 L 6.96875 19 L 4.96875 19 L 4.96875 17 z M 16.96875 17 L 18.96875 17 L 18.96875 19 L 16.96875 19 L 16.96875 17 z " />
                <rect
                    fill='currentColor'
                    fillOpacity='1'
                    stroke='none'
                    strokeWidth='0.109795'
                    strokeDasharray='none'
                    strokeOpacity='1'
                    id="rect1069"
                    width="9"
                    height="2.2"
                    x="3.084322"
                    y="5.7422366" />
                <rect
                    fill='currentColor'
                    fillOpacity='1'
                    stroke='none'
                    strokeWidth='0.109795'
                    strokeDasharray='none'
                    strokeOpacity='1'
                    id="rect1069-0"
                    width="9"
                    height="2.2"
                    x="-11.447"
                    y="6.4843221"
                    transform="rotate(-90)" />
            </svg>
        </SvgIcon>
    );
}